export default __webpack_public_path__ + "static/media/6.050a06a2.svg";